import React from 'react';
import './Space.scss'

const Space = (/*props*/) => (
    <div className="space space-default" />
)

export default Space;